<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'

export default {
  mixins: [onlyInputNumbers],
  components: {
    TitleWithRow,
    InputSelect,
    Label,
    Card
  },

  props: {
    nomeAba: {
      default: 'ILPF/Pecuária'
    },
    tiposCriacao: {
      type: Array,
      required: true
    },
    pratica: {
      required: true
    }
  },

  data () {
    return {
      criacao: {
        tipo: '',
        produtividade: '',
        especificacaoOutros: ''
      }
    }
  },

  computed: {
    disableButton () {
      return !(
        this.criacao.tipo &&
        this.criacao.produtividade &&
        ((this.containsOption(this.criacao.tipo, 'OUTROS', 'especificacaoOutros') && this.criacao.especificacaoOutros) || !this.containsOption(this.criacao.tipo, 'OUTROS', 'especificacaoOutros'))
      )
    },
    getAppenderText () {
      switch (this.criacao.tipo) {
        case 'BOVINOCULTURA_DE_CORTE':
          return 'hectare'
        case 'BOVINOCULTURA_LEITEIRA':
          return 'hectare'
        case 'OVINOS':
          return 'hectare'
        default:
          return 'hectare'
      }
    }
  },
  methods: {
    containsOption (parent, option, model) {
      let contains
      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.criacao)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    },
    btnAdicionar () {
      this.pratica.pecuarias.push({
        ...this.criacao
      })
      this.criacao = {
        tipo: '',
        produtividade: '',
        especificacaoOutros: ''
      }
    },
    btnApagar (index) {
      this.pratica.pecuarias.splice(index, 1)
    },
    btnEditar (pecuaria, index) {
      this.criacao = {
        tipo: pecuaria.tipo,
        produtividade: pecuaria.produtividade,
        especificacaoOutros: pecuaria.especificacaoOutros
      }
      this.btnApagar(index)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Tipo de criação pecuária e produtividade" />
    <el-row :gutter="20">
      <InputSelect
        :label="'Tipo de criação'"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="!pratica.pecuarias.length ? 'required' : ''"
        :opcoes="tiposCriacao"
        v-model="criacao.tipo"
        :widthColumn="8"
      />

      <validation-provider :rules="!pratica.pecuarias.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Qual tipo '">
        <el-col :span="8" v-if="containsOption(criacao.tipo, 'OUTROS', 'especificacaoOutros')">
          <Label label="Qual tipo?" :obrigatorio="true" />
          <el-input
            v-model="criacao.especificacaoOutros"
            style="width: 100%"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider :rules="!pratica.pecuarias.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Produtividade '">
        <el-col :span="8">
          <Label label="Produtividade" :obrigatorio="true" />
          <el-input
            v-model="criacao.produtividade"
            placeholder="Número de animais"
            style="width: 100%"
            clearable
            :onkeypress="onlyInputNumbers"
            :class="{'input erro' : errors.length}"
          >
            <template class="el-input-group__append" slot="append">{{ getAppenderText }}</template>
          </el-input>
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row style="width: 100%; top: 20px; display: flex; justify-content: flex-end;">
      <el-button
        :disabled="disableButton"
        round type="primary"
        @click="btnAdicionar()"
      >
        Adicionar
      </el-button>
    </el-row>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(l, i) in pratica.pecuarias" :key="i+l.tipo">
        <Card
          :objeto="{
            ...l,
            tipo: pratica.pecuarias ? tiposCriacao.find(pecuaria => pecuaria.id === l.tipo).nome : '-'
          }"
          :deletar="() => btnApagar(i)"
          :editar="() => btnEditar(l, i)"
          titulo="Pecuária"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";
/deep/ .el-input-group__append {
  color: $--color-text-regular
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/ILPF/IlpfPecuaria.vue